import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getShareClassdetails,
  getShareClassFeedetails,
} from "../../actions/assetShareClassAction";
import { UrlPath } from "../../../config/routeConfig";
import moment from "moment";
import { SBAComboBox, SBADropDown } from "../../UiComponents/SBADropDown";
import { CurrencyFormat } from "../../utils/currencyFormattter";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import {  useLocation } from "react-router-dom";
export const AssetShareClass = () => {

  const params = useParams();
  const history = useNavigate();
  const dispatch = useDispatch();
  const AssetId=params.Asset;
  const Gstate = useSelector((state) => state) || {};
  const isEditable =Gstate.authorizationData.isEditable;

    const ShareclassFee = Gstate.shareClassFeeData.shareClassFeeData || [];
    const ShareclassDetails = Gstate.shareClassData.shareClassData || [];
    const shareClassList = Gstate?.assetShareClass?.assetShareClass || [];
   
  const [ShareClass, setShareClass] = useState();
  const [ShareClassId, setShareClassId] = useState([]);
  const [render, setRender] = useState(true);
  const [loading,setLoading]=useState(true); 

  const [shareClassItem,setShareClassItem]=useState();
  const locationData = useLocation();
  const shid = locationData.state !==null? locationData.state.shareClassId === null ? shareClassList[0]?.ShareClassId : locationData.state.shareClassId:"";
  const shname = locationData.state !==null?locationData.state.shareClassName === null ? shareClassList[0]?.ShareClassName : locationData.state.shareClassName:"";

    useEffect(() => {
    setShareClassItem({ShareClassId:shid?shid:shareClassList[0]?.ShareClassId,ShareClassName:shname?shname:shareClassList[0]?.ShareClassName});
      setShareClassId(shid?shid:shareClassList[0]?.ShareClassId);
        if (shareClassList.length > 0) {
            dispatch(getShareClassdetails(shid ? shid : shareClassList[0]?.ShareClassId));
            dispatch(getShareClassFeedetails(shid ? shid : shareClassList[0]?.ShareClassId));
        }
       
        else {
          dispatch(getShareClassdetails(shid ? shid : null));
          dispatch(getShareClassFeedetails(shid ? shid : null));
      }
  },[shareClassList,render,AssetId]);
  useEffect(()=>{
    setTimeout(()=>{
setLoading(false);
    },500)
  },[])
  const ShareClassDropDownChanged = (e) => {
    setShareClassItem(e.value);
    dispatch(getShareClassdetails(e.value.ShareClassId));
    dispatch(getShareClassFeedetails(e.value.ShareClassId));
    setShareClassId(e.value.ShareClassId);
    setShareClass(e.value.ShareClassName);
  }
  return (
    <div className="share-tab">
      {loading ? <><LoadingScreen/></>:<>
      <div style={{ width: "300px", marginLeft: "auto" }}>
        {/* <ShareClassDropDown DropDownListChanged={ShareClassDropDownChanged} AssetId={AssetId} /> */}
        <SBAComboBox data={shareClassList} value={shareClassItem} textField={'ShareClassName'} dataItemKey={'ShareClassId'} onChange={ShareClassDropDownChanged}/>
      </div>
      <div class="col-lg-12 px-0">
        <div className="row p-2">
          <div class="row detail position-relative m-0 p-3 pt-5 w-100">
            <div className="col-md-8">
              <div class="row" style={{ marginBottom: "10px" }}>
                <div class="col-sm-4">
                <div className="mb-2" ><input type="checkbox" checked={ShareclassDetails[0] ? ShareclassDetails[0].IsDefault : ""} /> Default
                </div>
                </div>
                  <div class="col-sm-4">   <span class="fw-medium">Tax Reporting</span>
                  <p class="fw-medium mb-0">{ShareclassDetails[0]?.TaxReportingName ? ShareclassDetails[0].TaxReportingName : "NA"}</p></div>
                  <div className="col-sm-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox"
                      checked={ShareclassDetails[0] ? ShareclassDetails[0].VotingShares : ''}
                    />
                    <span >Voting Shares</span>
                  </label>
                </div>
              </div>

              <div class="row" style={{ marginBottom: "10px" }}>
                <div class="col-sm-4">
                <span class="fw-medium">Share Class</span>
                  <p class="fw-medium mb-0">{ShareclassDetails[0] ? ShareclassDetails[0].ShareClassName : "NA"}</p>
                </div>
                <div class="col-sm-4"> <span class="fw-medium">Tracking Frequency</span>
                  <p class="fw-medium mb-0">{ShareclassDetails[0]?.TrackingFrequencyName ? ShareclassDetails[0].TrackingFrequencyName : "NA"}</p></div>
                  <div className="col-sm-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox"
                      checked={ShareclassDetails[0]?.NewIssues ? ShareclassDetails[0].NewIssues : false}
                    />
                    <span > New Issues</span>
                  </label>
                </div>
              </div>
              <div class="row" style={{ marginBottom: "10px" }}>
                <div class="col-sm-4">
                   <span class="fw-medium">Minimum Investment</span>
                  <p class="fw-medium mb-0">
                    {ShareclassDetails[0]
                      ? ShareclassDetails[0].MinInvestment==="NA"?0 : CurrencyFormat(ShareclassDetails[0].MinInvestment,0)
                      : "NA"}
                  </p>

                </div>
                <div class="col-sm-4">
                  <span class="fw-medium">Tracked By</span>
                  <p class="fw-medium mb-0">
                    {ShareclassDetails[0]?.TrackingByName
                      ? ShareclassDetails[0].TrackingByName
                      : "NA"}
                  </p>
                </div>
                <div className="col-sm-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox"
                      checked={ShareclassDetails[0] ? ShareclassDetails[0].Accredited : ''}
                    />
                    <span> Accredited</span>
                  </label>
                </div>
              </div>

              <div class="row" style={{ marginBottom: "10px" }}>
                <div class="col-sm-4">
                  <span class="fw-medium">Effective Date</span>
                  <p class="fw-medium mb-0">
                    {ShareclassDetails[0]
                      ? moment(ShareclassDetails[0]?.EffectiveDate).format(
                        "MM-DD-YYYY"
                      )
                      : "NA"}
                  </p>
                </div>
                 
                <div class="col-sm-4">
                  <span class="fw-medium">Initial NAV</span>
                  <p class="fw-medium mb-0">
                    {ShareclassDetails[0] ? CurrencyFormat(ShareclassDetails[0].InitialNAV,0) : "NA"}
                  </p>
                </div>
                
                <div className="col-sm-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox" className="me-1"
                      checked={ShareclassDetails[0] ? ShareclassDetails[0].QualifiedPurchaser : false}
                    />
                    <span> Qualified Purchaser</span>
                  </label>
                </div>
                
              </div>

              <div class="row" style={{ marginBottom: "10px" }}>
                <div class="col-sm-4">
                  <span class="fw-medium">Investment Currency</span>
                  <p class="fw-medium mb-0">{
                  ShareclassDetails[0]?.SubscriptionCurrencyIdList.length!==0 ? ShareclassDetails[0]?.SubscriptionCurrencyIdList.map((item,index)=>{
                    if(ShareclassDetails[0]?.SubscriptionCurrencyIdList.length-1!==index)
                    return <span className="ms-1">{item.CurrencyName},</span>
                    else
                    return <span className="ms-1">{item.CurrencyName}</span>
                  }) :"NA"
                }</p>
                </div>
                <div class="col-sm-4">
                <span class="fw-medium">Liquidity Abbreviation</span>
                  <p class="fw-medium mb-0">{ShareclassDetails[0]?.LiquidityTermsAbrev ? ShareclassDetails[0].LiquidityTermsAbrev : "NA"}</p>
                
                </div>
                <div className="col-sm-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox" className="me-1"
                      checked={ShareclassDetails[0] ? ShareclassDetails[0].QualifiedClient : false}
                    />
                    <span> Qualified Client</span>
                  </label>
                </div>

              </div>
              <div class="row" style={{ marginBottom: "10px" }}>
                <div class="col-sm-4">
                  <span class="fw-medium">Subscription Frequency</span>
                  <p class="fw-medium mb-0">{ShareclassDetails[0]?.SubscriptionFrequencyName ? ShareclassDetails[0].SubscriptionFrequencyName : "NA"}</p>
                </div>
               
                <div className="col-sm-4">
                  
                </div>
                <div className="col-sm-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox"
                      checked={ShareclassDetails[0] ? ShareclassDetails[0].BusinessDays : ''}
                    />
                    <span> Business Days</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4 p-2" >
              <div class="detail m-0 p-3">
                <div className="row p-0" style={{ marginBottom: "10px" }}>
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox"
                      disabled={true}
                      // checked={ShareclassFee[0]?.IsMgmtFeeFreqPassThrough}
                    />
                    <span>Tiered Mgmt Fee</span>
                  </label>
                </div>

                <div class="row p-0" style={{ marginBottom: "10px" }}>
                  <div class="col-sm-4">
                    <span class="fw-medium">Management Fee</span>
                    <p class="fw-medium mb-0">
                      {ShareclassFee[0]
                        ? ShareclassFee[0].MgmtFee === null
                          ? "NA"
                          : ShareclassFee[0].MgmtFee + "%"
                        : "NA"}
                    </p>
                  </div>
                  <div class="col-sm-4">
                    <span class="fw-medium">Fee Frequency</span>
                    <p class="fw-medium mb-0">
                      {ShareclassFee[0]
                        ? ShareclassFee[0].MgmtFeeFrequencyName
                        : "NA"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="detail mt-1 p-3">
                <div className="row p-0" style={{ marginBottom: "10px" }}>
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox"
                      disabled={true}
                    />
                    <span>Tiered Performance Fee</span>
                  </label>
                </div>

                <div class="row p-0" style={{ marginBottom: "10px" }}>
                  <div class="col-sm-4">
                    <span class="fw-medium">Performance Fee</span>
                    <p class="fw-medium mb-0">
                      {ShareclassFee[0]
                        ? ShareclassFee[0].PerfFee === null
                          ? "NA"
                          : ShareclassFee[0].PerfFee + "%"
                        : "NA"}
                    </p>
                  </div>
                  <div class="col-sm-4 " style={{ width: "50%" }}>
                      
                  
                  <div>
                  <span class="fw-medium">
                      Payment Frequency 
                    </span>
                    <p class="fw-medium mb-0">
                    {ShareclassFee[0]?.PerfFeePaymentFrequencyName
                        ? ShareclassFee[0].PerfFeePaymentFrequencyName
                        : "NA"}
                    </p>
                  </div>
                  <div>
                  <span class="fw-medium">
                  Accural Frequency
                    </span>
                    <p class="fw-medium mb-0">
                       {ShareclassFee[0]?.PerfFeeAccrualFrequencyName
                        ? ShareclassFee[0].PerfFeeAccrualFrequencyName
                        : "NA"}

                    </p>
                  </div>
                   
                  </div>
                </div>

                <div class="row p-0" style={{ marginBottom: "10px" }}>
                  <div class="col-sm-4">
                    <span class="fw-medium">Hurdle Rate </span>
                    <p class="fw-medium mb-0">
                      {ShareclassFee[0] ? ShareclassFee[0].HurdleRateName : "NA"}
                    </p>
                  </div>
                  <div class="col-sm-4">
                    <span class="fw-medium">Hurdle Value</span>
                    <p class="fw-medium mb-0">
                      {ShareclassFee[0]
                        ? ShareclassFee[0].HurdleValue === null
                          ? "NA"
                          : ShareclassFee[0].HurdleValue + "%"
                        : "NA"}
                    </p>
                  </div>
                </div>
                <div class="row p-0" style={{ marginBottom: "10px" }}>
                  <div className="col-sm-4" style={{ marginBottom: "10px" }}>
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                      <input className="me-1"
                        type="checkbox"
                        checked={ShareclassFee[0]?.LossRecovery}
                      />
                      <span>Loss Recovery</span>
                    </label>
                  </div>

                  <div class="col-sm-4">
                    {" "}
                    <span class="fw-medium">Recovery Reset</span>
                    <p class="fw-medium mb-0">
                      {ShareclassFee[0]
                        ? ShareclassFee[0].LostRecoveryResetName
                        : "NA"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {ShareClassId && <Link to={isEditable && `${UrlPath.AssetShareClassEdit}${params.Asset}/${ShareClassId}`} className={isEditable ? "position-absolute edit_iconShareClass" : " position-absolute edit_iconShareClass disabledControl"} ><i class="fa-solid fa-pencil SBA_icon"></i></Link>}
            <Link to={isEditable && `${UrlPath.AssetShareClassAdd}${params.Asset}`} className={isEditable ? "position-absolute add_iconShareClass" : " position-absolute add_iconShareClass disabledControl"}  ><i class="fa-solid fa-add SBA_icon"></i></Link>
          </div>
        </div>
      </div></>}
    </div>
  );
};
